import { createSharedContext } from "@rshbintech.dboul/shared-context";
import { SnowPlowAnalyticsContextProps } from "./types";
import { SNOW_PLOW_ANALYTICS_CONTEXT_KEY } from "./constants";

export const SnowPlowAnalyticsContext = createSharedContext<
  SnowPlowAnalyticsContextProps | undefined
>(SNOW_PLOW_ANALYTICS_CONTEXT_KEY, undefined);
